import { render, staticRenderFns } from "./ChoiceSubjects.vue?vue&type=template&id=5caf1cd0&scoped=true&"
import script from "./ChoiceSubjects.vue?vue&type=script&lang=js&"
export * from "./ChoiceSubjects.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceSubjects.vue?vue&type=style&index=0&id=5caf1cd0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caf1cd0",
  null
  
)

export default component.exports